export const statusCodes = {
  SUCCESS: 'success',
  FAIL: 'fail'
}
